import {
    Box,
    Image,
    useColorModeValue,
    Heading,
    useDisclosure,
    Drawer,
    DrawerOverlay,
    DrawerContent,
    DrawerBody,
    IconButton,
    Tooltip,
} from '@chakra-ui/react';
import axios from 'axios';
import NavLink from '../NavLink';
import logo from '../../assets/logoazul.png';
import logoBranco from '../../assets/logobranco.png';
import logoLevEduca from '../../assets/logo_leveduca.png';
//import logoLevEduca from '../../assets/logo_leveduca.jpg';
import ThemeSelector from '../themeSelector';
import Button from '../diversos/button';
import { HamburgerIcon } from '@chakra-ui/icons';
import { FaGooglePlay } from 'react-icons/fa';
import { useAppDispatch, useAppSelector } from '../../reduxHooks';
import { logout } from '../../redux/reducers/login';
import Loading from '../../components/Loading';
import { useState } from 'react';

const Header = (props: any) => {
    const dispatch = useAppDispatch();
    const reduxAuth = useAppSelector((state) => state.login);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const logoUsado = useColorModeValue(logo, logoBranco);
    const sombra = useColorModeValue('lg', 'dark-lg');
    const bg = useColorModeValue('white', 'gray.800');
    const bgMenu = useColorModeValue('gray.50', 'gray.700');
    const bgIcone = useColorModeValue('teal.500', 'gray.600');
    const [carregando, setCarregando] = useState(false);

    const sair = () => {
        console.log('CLICOU PARA SAIR');
        dispatch(logout());
    };

    const menuGrande = () => {
        return (
            <Box
                display={{ lg: 'flex', xl: 'flex', base: 'none' }}
                backgroundColor={bgMenu}
                mx={{
                    lg: -3,
                    xl: -3,
                    base: -1,
                }}
                px={{
                    lg: 3,
                    xl: 3,
                    base: 1,
                }}
            >
                {reduxAuth.associado.empresa !== 0 ? (
                    <>
                        <NavLink to="/dependentes" onClick={onClose}>
                            Dependentes
                        </NavLink>
                        <NavLink to="/guias">Guias</NavLink>
                    </>
                ) : (
                    <>
                        <NavLink to="/">Emissão de Boletos/Pagamentos</NavLink>
                        <NavLink to="/dependentes" onClick={onClose}>
                            Dependentes
                        </NavLink>
                        <NavLink
                            to="/recorrente"
                            tooltip="Cadastrar cartão para recebimento automático"
                        >
                            Pagamento Recorrente
                        </NavLink>
                        <NavLink to="/extrato">Mensalidades Pagas</NavLink>
                        <NavLink to="/guias">Guias</NavLink>
                        <NavLink to="/declaracao">
                            Declaração de Quitação
                        </NavLink>
                    </>
                )}

                <NavLink to="#" onClick={sair}>
                    Sair
                </NavLink>
            </Box>
        );
    };

    const menuCompacto = () => {
        return (
            <Drawer
                placement="left"
                onClose={onClose}
                isOpen={isOpen}
                //@ts-ignore
                display={{ lg: 'none', xl: 'none' }}
            >
                <DrawerOverlay>
                    <DrawerContent>
                        <DrawerBody>
                            {reduxAuth.associado.empresa !== 0 ? (
                                <>
                                    <NavLink
                                        to="/dependentes"
                                        onClick={onClose}
                                    >
                                        Dependentes
                                    </NavLink>
                                    <NavLink to="/guias" onClick={onClose}>
                                        Guias
                                    </NavLink>
                                </>
                            ) : (
                                <>
                                    <NavLink to="/" onClick={onClose}>
                                        Emissão de Boletos/Pagamentos
                                    </NavLink>
                                    <NavLink
                                        to="/dependentes"
                                        onClick={onClose}
                                    >
                                        Dependentes
                                    </NavLink>
                                    <NavLink
                                        to="/recorrente"
                                        onClick={onClose}
                                        tooltip="Cadastrar cartão para recebimento automático"
                                    >
                                        Pagamento Recorrente
                                    </NavLink>
                                    <NavLink to="/extrato" onClick={onClose}>
                                        Mensalidades Pagas
                                    </NavLink>
                                    <NavLink to="/guias" onClick={onClose}>
                                        Guias
                                    </NavLink>
                                    <NavLink to="/declaracao" onClick={onClose}>
                                        Declaração de Quitação
                                    </NavLink>
                                </>
                            )}

                            <NavLink to="#" onClick={sair}>
                                Sair
                            </NavLink>
                            <Box>
                                <Button
                                    mt={2}
                                    mr={2}
                                    w={100}
                                    onClick={abrirLevEduca}
                                >
                                    {!carregando && (
                                        <Image src={logoLevEduca} mr={2} />
                                    )}
                                    {carregando && <Loading />}
                                </Button>
                                <Tooltip hasArrow label="Baixe nosso app">
                                    <a
                                        href="https://play.google.com/store/apps/details?id=com.cardassi.associados"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <IconButton
                                            mt={2}
                                            as={FaGooglePlay}
                                            bg={bgIcone}
                                            mr={2}
                                            color="white"
                                            aria-label="Baixe na Play Store"
                                        />
                                    </a>
                                </Tooltip>
                                <ThemeSelector mt={2} />
                            </Box>
                        </DrawerBody>
                    </DrawerContent>
                </DrawerOverlay>
            </Drawer>
        );
    };

    async function abrirLevEduca() {
        setCarregando(true);
        try {
            await axios
                .post(
                    'https://lms-backend.leveduca.com.br/api/login-provedor',
                    {
                        username: reduxAuth.associado.cpf,
                        senha: reduxAuth.associado.cpf,
                        plataforma: '680',
                    }
                )
                .then((retorno) => {
                    console.log('RETORNO', retorno.data);
                    const janela = window.open('', '_blank');
                    if (retorno.data.usuario) {
                        janela!.location.href = `https://app.leveduca.com.br/#/token/${retorno.data.usuario.token}`;
                    } else {
                        janela!.location.href =
                            'https://app.leveduca.com.br/#/cardassi';
                    }
                });
        } finally {
            setCarregando(false);
        }
    }

    return (
        <Box
            boxShadow={sombra}
            borderRadius={4}
            px={{
                lg: 3,
                xl: 3,
                base: 1,
            }}
            position={{ lg: 'sticky', xl: 'sticky', base: undefined }}
            top="0"
            zIndex={999}
            backgroundColor={bg}
            mb={3}
        >
            {reduxAuth.isLoggedIn ? (
                <>
                    <Box
                        p="3"
                        display="flex"
                        justifyContent={{
                            lg: 'left',
                            xl: 'left',
                            base: 'center',
                        }}
                    >
                        <Image src={logoUsado} />
                        <Box
                            w="100%"
                            flexDir="row-reverse"
                            display={{
                                lg: 'flex',
                                xl: 'flex',
                                base: 'none',
                            }}
                        >
                            <ThemeSelector />
                            <Tooltip hasArrow label="Baixe nosso app">
                                <a
                                    href="https://play.google.com/store/apps/details?id=com.cardassi.associados"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <IconButton
                                        as={FaGooglePlay}
                                        // eslint-disable-next-line react-hooks/rules-of-hooks
                                        bg={useColorModeValue(
                                            'teal.500',
                                            'gray.600'
                                        )}
                                        mr={2}
                                        color="white"
                                        aria-label="Baixe na Play Store"
                                    />
                                </a>
                            </Tooltip>

                            <Button mr={2} w={100} onClick={abrirLevEduca}>
                                {!carregando && (
                                    <Image src={logoLevEduca} mr={2} />
                                )}
                                {carregando && <Loading />}
                            </Button>
                        </Box>
                    </Box>
                    {menuGrande()}
                    {menuCompacto()}

                    <Box mb={2} mt={2}>
                        <Box
                            display="flex"
                            flexDir={{ lg: 'row', base: 'column' }}
                            w="100%"
                            mb={2}
                        >
                            <Box w="150px">
                                <Heading size="sm">
                                    Contrato: {reduxAuth.associado.inscricao}
                                </Heading>
                            </Box>
                            <Box flex="1">
                                <Heading size="sm">
                                    Nome: {reduxAuth.associado.nome}
                                </Heading>
                            </Box>
                        </Box>
                    </Box>
                    <Button
                        onClick={onOpen}
                        display={{ lg: 'none', xl: 'none' }}
                        mb={2}
                    >
                        <HamburgerIcon w={6} h={6} />
                    </Button>
                </>
            ) : null}
        </Box>
    );
};

export default Header;
